import { Auth, User } from 'firebase/auth';
import { ReactNode } from 'react';

export type Credentials = {
  email: string;
  password: string;
};

export interface IFirebaseContext {
  googleUser: Partial<User> | null;
  loading?: boolean;
  login?: (credentials: Credentials) => Promise<void>;
  logout?: (redirectUrl?: string) => Promise<void>;
  updatePassword?: (password: string) => Promise<void>;
  reauthenticateUser?: (password: string) => Promise<void>;
  signInWithToken?: (token: string) => Promise<void>;
}

export type FirebaseProviderProps = { children: ReactNode; auth: Auth };

export class FirebaseAuthError extends Error {
  code: string;

  constructor(message: string, code = '') {
    super(message);
    this.name = this.constructor.name;
    this.code = code;
  }
}
